import { render, staticRenderFns } from "./ChangeLastName.vue?vue&type=template&id=56d365d9&"
import script from "./ChangeLastName.vue?vue&type=script&lang=js&"
export * from "./ChangeLastName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports